import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function SitemapPage() {
  useEffect(() => {
    document.title = 'Sitemap | 888 Sourcing Limited';
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a1628] text-white" data-id="element-665">
      <Navigation data-id="element-666" />

      <main className="pt-32 pb-24" data-id="element-667">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-668">
          {/* Back Button */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="mb-8" data-id="element-669">
            <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-[#d4a853] transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-670">
              <ArrowLeft size={16} data-id="element-671" />
              Back to Home
            </Link>
          </motion.div>

          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="mb-12" data-id="element-672">
            <div className="flex items-center gap-3 mb-6" data-id="element-673">
              <div className="h-px w-12 bg-[#d4a853]" data-id="element-674" />
              <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm" data-id="element-675">
                Navigation
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-676">
              Sitemap
            </h1>
            <p className="text-gray-400 text-lg max-w-3xl" data-id="element-677">
              Complete overview of all pages and sections on the 888 Sourcing
              Limited website. Use this page to quickly navigate to any part of
              our site.
            </p>
          </motion.div>

          {/* Sitemap Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-678">
            {sitemapSections.map((section, sectionIndex) => <motion.div key={section.title} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + sectionIndex * 0.1
          }} className="bg-[#1a2d4a]/30 border border-white/10 p-6" data-id="element-679">
                <h2 className="text-xl font-bold text-[#d4a853] mb-6 uppercase tracking-wider" data-id="element-680">
                  {section.title}
                </h2>
                <ul className="space-y-3" data-id="element-681">
                  {section.links.map((link, linkIndex) => <motion.li key={linkIndex} initial={{
                opacity: 0,
                x: -10
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: 0.3 + sectionIndex * 0.1 + linkIndex * 0.05
              }} data-id="element-682">
                      {link.isExternal ? <a href={link.path} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#d4a853] transition-colors text-sm flex items-center gap-2 group" data-id="element-683">
                          <span className="w-1.5 h-1.5 bg-[#d4a853] rounded-full opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-684" />
                          {link.name}
                          <ExternalLink size={12} className="opacity-50" data-id="element-685" />
                        </a> : <Link to={link.path} className="text-gray-300 hover:text-[#d4a853] transition-colors text-sm flex items-center gap-2 group" data-id="element-686">
                          <span className="w-1.5 h-1.5 bg-[#d4a853] rounded-full opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-687" />
                          {link.name}
                        </Link>}
                    </motion.li>)}
                </ul>
              </motion.div>)}
          </div>

          {/* Contact Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="mt-16 bg-[#1a2d4a] border border-[#d4a853]/30 p-8 text-center" data-id="element-688">
            <h2 className="text-2xl font-bold text-white mb-4" data-id="element-689">
              Can't Find What You're Looking For?
            </h2>
            <p className="text-gray-400 mb-6 max-w-2xl mx-auto" data-id="element-690">
              If you need assistance or have questions about our services,
              please don't hesitate to contact us directly.
            </p>
            <Link to="/#contact" className="inline-block bg-[#d4a853] text-[#0a1628] px-8 py-3 font-bold uppercase tracking-wider hover:bg-white transition-colors" data-id="element-691">
              Contact Us
            </Link>
          </motion.div>

          {/* Back to Top */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.7
        }} className="mt-12 text-center" data-id="element-692">
            <Link to="/" className="inline-flex items-center gap-2 text-[#d4a853] hover:text-white transition-colors font-bold uppercase tracking-wider text-sm" data-id="element-693">
              <ArrowLeft size={16} data-id="element-694" />
              Return to Homepage
            </Link>
          </motion.div>
        </div>
      </main>

      <Footer data-id="element-695" />
    </div>;
}